import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import TextInput, { InputProps } from 'components/text-input';

import lock from 'assets/images/lock.svg';

type AuthCodeInputProps = {} & Omit<InputProps, 'value' | 'icon'>;

const makeMask = (mask: string | number | readonly string[] | undefined) => {
  if (!mask) {
    return '000000';
  }
  let res = '';
  for (let i = 0; i < String(mask).length; i++) {
    res += '0';
  }
  return res;
};

const AuthCodeInput: React.FC<AuthCodeInputProps> = (props) => {
  const { onChange, ...rest } = props;
  const mask = makeMask(props.defaultValue);
  const { ref, value } = useIMask({ mask });

  useEffect(() => {
    onChange?.(value);
  }, [value, onChange]);

  return <TextInput {...rest} inputMode='numeric' placeholder={mask} icon={lock} ref={ref} />;
};

export default AuthCodeInput;
